import React from 'react';
import Proptypes from 'prop-types';

import MultiType from './multiType';

function QuestionItemKind({ kind, setChoices }) {
  return (
    <>
      {kind && kind !== 'Evidence' && (
        <MultiType kind={kind} setChoices={setChoices} />
      )}
    </>
  );
}

QuestionItemKind.propTypes = {
  kind: Proptypes.string.isRequired,
  setChoices: Proptypes.func.isRequired,
};

export default QuestionItemKind;
